<template>

<div id="contacto">
      <div class="row justify-content-center ">
          <div class="col-lg-8">
            <card gradient="secondary" shadow body-classes="p-lg-5">
              <h4 class="mb-1">¿Desea más información?</h4>
              <p class="mt-0">Le invitamos a conocer nuestra tecnología sin compromiso alguno.</p>
              <h5 class="">Puede llamar a nuestro Call-Center.</h5>
              <base-button type="default" round block size="lg"  icon="fa fa-phone" @click="telLink('+34900732022')">
                 Call-Center 900 732 022
            </base-button>
              <h5 class="mt-3">Rellene el formulario si prefiere que le llamemos</h5>
              <!-- <base-input
                class="mt-5"
                alternative
                placeholder="Your name"
                addon-left-icon="ni ni-user-run"
              >
              </base-input> -->
              <base-input
                alternative
                placeholder="Dirección Email"
                addon-left-icon="ni ni-email-83"
                v-model="email"
              ></base-input>
              <base-input
                alternative
                placeholder="Indique su teléfono"
                addon-left-icon="fa fa-phone"
                v-model="telefono"
              >
              </base-input>
              <base-input
                alternative
                addon-left-icon="fa fa-globe"
                placeholder="¿Cómo nos ha conocido?"
                v-model="conocido"
              >
              </base-input>
              <base-input class="mb-4">
                <textarea
                  v-model="msg"
                  class="form-control form-control-alternative"
                  name="name"
                  rows="4"
                  cols="80"
                  placeholder="Mensaje..."
                ></textarea>
              </base-input>
              <base-input>
                <input type="checkbox" id="agreement" v-model="agreement">
                <label for="agreement">&nbsp;Acepto la</label>
                <a href="#/avisolegal" target="_blank"> política de privacidad</a>&nbsp;
              </base-input>
              
              <base-button type="default" :disabled="!agreement" round block size="lg" @click="enviarEmail">
                Enviar Mensaje
              </base-button>
              <span :class="successClass">{{success}}</span>
                <!-- <div class="telefonos">Zona CENTRO/NORTE: Jaime Manzanares  <a href="tel:+34620010128">620 01 01 28</a></div>
                <div class="telefonos">Zona LEVANTE/BALEARES: Jose Antonio Blasco  <a href="tel:+34680403405">680 40 34 05</a></div>
                <div class="telefonos">Zona SUR/CANARIAS: Jose luís García  <a href="tel:+34636478824">636 47 88 24</a></div> -->
            </card>
          </div>
        </div>
</div>
</template>
<script>
import axios from "axios"
export default {
  name: "Contacto",
  data(){
    return{
        email:"",
        telefono:"",
        success:"",
        msg:"",
        conocido:"",
        successClass: 'text-green',
        agreement:false
    }
  },
  methods:{
    telLink(tel){
      window.open("tel:"+tel, '_self');
   },
      async enviarEmail(e){
        e.preventDefault();
        grecaptcha.ready(() => {
          //let keyrecaptcha='6Lcg41QpAAAAAMQ2wDYA9ryclG3RIYLcXHG6lu63'//localhost
          let keyrecaptcha='6LcoRlklAAAAAE3SgHyos1jSBhRG-NvwKESOy3MT'//notin.es
          grecaptcha.execute(keyrecaptcha, {action: 'email'}).then(async (token) => {
            console.log(token)
            console.log("enviarMail")
            if(this.email != "" || this.telefono.length > 0){
              console.log("email")
              if (this.validateEmail(this.email) || this.telefono.length > 0){
                  var data =   {
                    "perfil":"info_recaptcha",
                    "cuerpo":"Este es un email de:  " + this.email + '<br>'+ (this.msg != ""?this.msg:"Estoy interesado en una demostracion de NOTIN"),
                    "is_cuerpo_html":true,
                    "asunto":"Contacto Notin.es",
                    "destinatarios":[{"nombre":"José Luis Notin","direccion":"comercial@notin.net"}],
                    "destinatarios_cco":[{"nombre":"webNotin","direccion":"web@notin.net"},{"nombre":"modelos","direccion":"modelos@notin.net"}],
                    "recaptcha":{
                      "id_credential":1,
                      "token":token,
                      "action":"email"
                    }//,"data":{"id_notaria":23,"Fecha":"1736263781974","Name":"joaquin","Email":"joaquinb@dfsdf.com","Phone":"55546463324","Subject":"Asunto ","Message":"Mensaje "}
                    }

                  if(this.telefono!=""){
                    data.cuerpo += '<br>Llameme al telefono: ' + this.telefono;
                  }
                  if(this.conocido!=""){
                    data.cuerpo += '<br>Nos ha conocido mediante: ' + this.conocido;
                  }
                  // var formData = new FormData();
                  // for (var key in data) {
                  //     formData.append(key, data[key])
                  // }
                  try{
                      var respuesta = await axios.post("https://mailing.notin.es/api/email",data,{headers: { 'Content-Type': 'application/json' }})
                      this.success = "Gracias por su colaboración."
                      this.successClass = 'text-green';
                      setTimeout(() => this.$router.push("donde-estamos"), 2000)
                  }catch(e){
                      console.log( e );
                  }
              }else{
                  this.success = 'Por favor, introduzca su email para ponernos en contacto con usted.';
                  this.successClass = 'text-red';
                  //$('.success').fadeIn(1000);
              }
            }else{
              this.success = 'Por favor, introduzca su email para ponernos en contacto con usted.';
              this.successClass = 'text-red';
            }  
          });
        })
      },
      validateEmail(email){
            var re = /\S+@\S+\.\S+/;
            return re.test(email);
      }
  }
}

</script>